import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { of } from 'rxjs/observable/of';
import { Discount } from '../interfaces/discount';

@Injectable()
export class DiscountsService {
  getAllDiscounts(): Observable<Discount[]> {
    return of(environment.DISCOUNTS);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/discounts.service.ts